import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { ISocialMediaPost } from "../../../../../dataObjects/models/digitalMedia/SocialMediaPost";
import { enumSocialMediaPostType } from "../../../../enums";
import { ISocialMediaPostDisplaySpecs } from "../ISocialMediaPostDisplaySpecs";

/**
 * @function deriveDisplaySpecsForLinkedIn Derives the specs needed to display a LinkedIn Social Media Post from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function deriveDisplaySpecsForLinkedIn(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // set default displaySpecs values for LinkedIn
  let displaySpecs: ISocialMediaPostDisplaySpecs = { socialMediaPostType: enumSocialMediaPostType.Undefined, url: '', width: '100%', height: '100%' };;

  // execute the regular expression against the url to determine if the url represents a standard LinkedIn EmbedUrl
  const matchEmbedUrl: RegExpExecArray | null = RegularExpressions.LinkedInEmbedUrl.exec(socialMediaPostRawReference);

  // if a match was made for a simple embed url...
  if (matchEmbedUrl && matchEmbedUrl.groups && matchEmbedUrl.groups.embedUrl) {
    // set the specs for displaying the post
    displaySpecs = { socialMediaPostType: enumSocialMediaPostType.LinkedIn, url: matchEmbedUrl.groups.embedUrl, width: '100%', height: '100%' };
  } else {
    // execute the regular expression against the url to determine if the url represents a LinkedIn IFrame with full specs
    const matchIFrameWithFullSpecs: RegExpExecArray | null = RegularExpressions.LinkedInIFrameWithFullSpecs.exec(socialMediaPostRawReference);

    // if a match was made for an <iframe>...
    if (matchIFrameWithFullSpecs && matchIFrameWithFullSpecs.groups) {
      // set the Social Media Post Type
      displaySpecs.socialMediaPostType = enumSocialMediaPostType.LinkedIn;

      // if the embedUrl is found...
      if (matchIFrameWithFullSpecs.groups.embedUrl) {
        displaySpecs.url = matchIFrameWithFullSpecs.groups.embedUrl;
      }

      // if the 'height' parameter was found, ... 
      if (matchIFrameWithFullSpecs.groups.height) {
        // convert to a number and set value into the displaySpecs.height variable
        displaySpecs.height = parseInt(matchIFrameWithFullSpecs.groups.height);
      }

      // if the 'width' parameter was found, ... 
      if (matchIFrameWithFullSpecs.groups.width) {
        // convert to a number and set value into the displaySpecs.width variable
        displaySpecs.width = parseInt(matchIFrameWithFullSpecs.groups.width);
      }
    }
  }

  return displaySpecs;
}
